import React from 'react';

const Separator = (props) => {
return ( 
       <span className='mt-1 inline-block p-2 h-full'>
        <span>°</span>
        </span>
    ) 
}

export default Separator;